// import icon from "../../../../assets/images/leftMenu/basePortal/icon_text.png"
let icon = "icon-portal-menu_text"
export default {
  name: "文本列表",
  id: "",
  type: "cxSystemText",
  componentType:"emptyLayoutComponent",
  thumbnail: icon,
  // typeId: "A056B2326670FAB9",
  typeId: "",
  children: []
}
